import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios.js';

const TicketForm = () => {
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('low'); // Prioridad por defecto
  const [category, setCategory] = useState('other');
  const [loading, setLoading] = useState(false);

  // 🟢 SOLUCIÓN: Usamos un array de objetos con 'value' para el backend y 'label' para el usuario.
  const categories = [
    { value: 'other', label: 'Consulta General' },
    { value: 'technical', label: 'Problema Técnico' },
    { value: 'feature_request', label: 'Sugerencia de Mejora' },
    { value: 'billing', label: 'Facturación y Pagos' },
    { value: 'bug', label: 'Problemas de Acceso a la Cuenta' }, // Asumimos que es un bug
  ];

  // Mapeo de categoría a prioridad
  const priorityMapping = {
    technical: 'high',
    billing: 'high',
    bug: 'medium',
    other: 'low',
    feature_request: 'low',
  };

  // Efecto para actualizar la prioridad automáticamente cuando cambia la categoría
  useEffect(() => {
    setPriority(priorityMapping[category] || 'low');
  }, [category]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const url = '/support/tickets';
      console.log('[DEBUG] Enviando ticket a:', url); // LOG para rastrear
      // Enviamos la prioridad que se gestiona internamente
      const { data } = await api.post(
        url,
        { subject, description, priority, category },
        config
      );
      toast.success(data.message || 'Ticket de soporte creado exitosamente.');
      setSubject('');
      setDescription('');
      setCategory('other'); // Resetear a la categoría por defecto
      setPriority('low'); // Resetear a la prioridad por defecto
    } catch (error) {
      console.error('[DEBUG] Error al enviar ticket:', error.response || error); // LOG para rastrear el error
      toast.error(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Enviar un Ticket de Soporte</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
            Asunto
          </label>
          <input
            type="text"
            id="subject"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Descripción
          </label>
          <textarea
            id="description"
            rows="5"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            disabled={loading}
          ></textarea>
        </div>

        <div>
          <label htmlFor="category" className="block text-sm font-medium text-gray-700">
            Categoría
          </label>
          <select
            id="category"
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            disabled={loading}
          >
            {categories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
        
        {/* Input oculto para ver la prioridad asignada (opcional, para debugging) */}
        <input type="hidden" value={priority} />

        <button
          type="submit"
          className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
            loading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
          }`}
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar Ticket'}
        </button>
      </form>
    </div>
  );
};

export default TicketForm;
